import { ValidatorFn, Validators } from "@angular/forms";
import { AppValidators } from "src/app/common/appValidators";

export const RequiredValidatorFunction: ValidatorFn[] = [Validators.required];
export const CredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.noSpace];
export const EmailCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([AppValidators.email]);
export const GuidCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([AppValidators.guid]);
export const CertificateThumbprintCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
    AppValidators.certificateThumbprint,
]);
export const CertificatePrivateKeyCredentialValidatorsFunctions: ValidatorFn[] = [AppValidators.certificatePrivateKey];
export const SalesforceInstanceUrlCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
    AppValidators.salesforceInstanceUrl,
]);
export const serviceNowInstanceUrlCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
    AppValidators.serviceNowInstanceUrl,
]);
export const ChatGptEnterpriseApiKeyCredentialValidatorsFunctions: ValidatorFn[] = CredentialValidatorsFunctions.concat([
    AppValidators.chatGptEnterpriseApiKey,
]);
